'use client';

import dayjs from 'dayjs';
import Image from 'next/image';
import Link from 'next/link';

import {
  PROMOTION_TYPE_TACTICAL_ADS,
} from '@/apis/server/new-car/v1/promotions/constants';
import { joinSgcmSite } from '@/utils/url/join/public';

import {
  PROMOTION_MODEL_COVER_IMAGE_HEIGHT,
  PROMOTION_MODEL_COVER_IMAGE_LOGO_HEIGHT,
  PROMOTION_MODEL_COVER_IMAGE_WIDTH,
  PROMOTION_POSTED_ON_DATE_FORMAT,
  TACTICAL_PROMOTION_ITEM_HEIGHT,
  TACTICAL_PROMOTION_ITEM_WIDTH,
} from './constants';
import styles from './styles.module.scss';
import type { Component } from './types';

export const PromoItem: Component = ({
  item,
  onItemClick,
  isExpired,
}) => (
  <button
    key={item!.id}
    className={styles.containerPromoItem}
    onClick={() => {
      onItemClick?.(item!.id);
    }}>
    { item?.promoType === PROMOTION_TYPE_TACTICAL_ADS && (
      <div className={styles.containerImage}>
        <Image
          alt="Promotion tactical ads image of vehicle"
          className={styles.imageTactical}
          height={TACTICAL_PROMOTION_ITEM_HEIGHT}
          src={`https://i.i-sgcm.com/new_cars/promos/${item?.dealer.id}/${item?.id}_customized_l.jpg`}
          width={TACTICAL_PROMOTION_ITEM_WIDTH} />
      </div>
    )}
    <div className={styles.containerPromoContent}>
      { item?.promoType !== PROMOTION_TYPE_TACTICAL_ADS && (
        <div>
          <Image
            alt="Promotion image of vehicle"
            className={styles.imageVehicleCover}
            height={item?.image?.includes('/logos/')
              ? PROMOTION_MODEL_COVER_IMAGE_LOGO_HEIGHT
              : PROMOTION_MODEL_COVER_IMAGE_HEIGHT}
            src={item?.dealer.type === 'pi'
              ? `https://i.i-sgcm.com/new_cars/cars/${item.carId}/${item.carId}_m.jpg`
              : item?.image || ''}
            width={PROMOTION_MODEL_COVER_IMAGE_WIDTH} />
        </div>
      )}
      <div className={styles.containerInfo}>
        <div className={styles.containerTitle}>
          <div className={styles.textTitle}>
            {item!.models.length > 1
              ? (
                <span className={styles.textMake}>
                  {item!.title}
                  {' '}
                  {item?.dealer.type === 'pi' ? '(PI)' : ''}
                </span>
              )
              : (
                item!.models.map(model => (
                  <span
                    key={model.title}
                    className={styles.textMake}>
                    {model.title}
                    {' '}
                    {item?.dealer.type === 'pi' ? '(PI)' : ''}
                  </span>
                ))
              )}
          </div>
          {isExpired && (
            <div className={styles.textExpire}>EXPIRED</div>
          )}
        </div>
        <div className={styles.textSummary}>
          {item!.summary}
        </div>
        <div className={styles.containerPostInfo}>
          <Link
            className={styles.textDealerName}
            href={joinSgcmSite(`/new_cars/newcars_PIdealer.php?dcode=${item!.dealer.id}`)}>
            {item!.dealer.name}
          </Link>
          <div className={styles.textPostOn}>
            Posted on:
            {' '}
            {dayjs(item?.postedOn)
              .format(PROMOTION_POSTED_ON_DATE_FORMAT)}
          </div>
        </div>
      </div>
    </div>
  </button>
);
